/*
 *		Copyright (c) 2011-2020 Acronis Incorporated. All rights reserved.
 *
 *	This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

angular.module('access.Nodes')
    .directive('accSignedNotarizedFilesDeleteWarning', ['$q', '$translate', 'NodeRevision', function ($q, $translate, NodeRevision) {
        return {
            scope: {
                items: '<',
                modal: '='
            },
            replace: true,
            template: '<span ng-show="message" ng-bind-html="message"></span>',
            link: function ($scope) {
                $scope.message = '';

                $q.all([
                    _anySignedNodes($scope.items),
                    _anySuccessfullyNotarized($scope.items)
                ]).then(function (results) {
                    var hasSignedNodes = results[0];
                    var hasNotarizedNodes = results[1];

                    if (hasSignedNodes && hasNotarizedNodes) {
                        $scope.message = $translate.instant('node_signed_notarized_revision_delete_warning');
                        _setModalTitle($translate.instant('node_signed_notarized_revision_delete_title'));
                    } else if (hasSignedNodes) {
                        $scope.message = $translate.instant('node_signed_revision_delete_warning');
                        _setModalTitle($translate.instant('node_signed_revision_delete_title'));
                    } else if (hasNotarizedNodes) {
                        $scope.message = $translate.instant('node_notarization_notarized_revision_delete_warning');
                    }
                });

                function _anySignedNodes(items) {
                    // TODO: replace with hasEsignature-method introduced by PR#2847 (ASRV-10540)
                    return $q.resolve(items.some(function (node) { return node.has_esignature; }));
                }

                function _anySuccessfullyNotarized(items) {
                    var nodesUnderNotarization = items.filter(function (node) {
                        return angular.isObject(node['latest_notarized_revision']);
                    });

                    if (nodesUnderNotarization.length === 0) {
                        return $q.resolve(false);
                    } else if (nodesUnderNotarization.some(function (item) { return _isSuccessfullyNotarized(item['latest_notarized_revision']); })) {
                        return $q.resolve(true);
                    } else {
                        return _anyAsyncSuccessfullyNotarized(nodesUnderNotarization);
                    }
                }

                function _anyAsyncSuccessfullyNotarized(items) {
                    var itemToCheck = items.splice(0, 1)[0];

                    return NodeRevision.query({ node_uuid: itemToCheck['uuid'] }).$promise
                        .then(function (revisions) {
                            if (revisions.some(_isSuccessfullyNotarized)) {
                                return true;
                            } else if (items.length) {
                                return _anyAsyncSuccessfullyNotarized(items);
                            } else {
                                return false;
                            }
                        });
                }

                function _isSuccessfullyNotarized(revision) {
                    return angular.isObject(revision.notarization) && revision.notarization['status'] === 'successful';
                }

                function _setModalTitle(title) {
                    if ($scope.modal && $scope.modal.title) {
                        $scope.modal.title = title;
                    }
                }
            }
        }
    }]);
